import { render, staticRenderFns } from "./DigitalVendorInvoicing.vue?vue&type=template&id=f05833ea&"
import script from "./DigitalVendorInvoicing.vue?vue&type=script&lang=js&"
export * from "./DigitalVendorInvoicing.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports